/**
 * IssueBoardSection Component
 * 이슈게시판 섹션
 */

import React, { useState } from 'react';
import { useAuth, USER_TIERS } from '../../contexts/AuthContext';
import { useCommunity, POST_TYPES } from '../../contexts/CommunityContext';
import { formatDate } from './utils';
import CommunityEditor from '../../components/CommunityEditor';

const IssueBoardSection = ({ onPostSelect }) => {
  const { user, isAuthenticated } = useAuth();
  const { getCommunityPosts, createPost } = useCommunity();

  const [showWriteForm, setShowWriteForm] = useState(false);
  const [newTitle, setNewTitle] = useState('');
  const [newContent, setNewContent] = useState('');
  const [message, setMessage] = useState('');

  const canPost = isAuthenticated && user?.tier !== USER_TIERS.GUEST;
  // 이슈 카테고리로 필터링 (임시로 question 카테고리 사용)
  const posts = getCommunityPosts('question');

  const handleCreatePost = (e) => {
    e.preventDefault();
    if (!newTitle.trim() || !newContent.trim()) return;

    createPost(POST_TYPES.COMMUNITY, newTitle, newContent, user, 'question', []);
    setNewTitle('');
    setNewContent('');
    setShowWriteForm(false);
    setMessage('이슈가 등록되었습니다.');
    setTimeout(() => setMessage(''), 3000);
  };

  return (
    <div className="section-container">
      <div className="section-header">
        <h1>이슈게시판</h1>
        <p>버그 리포트, 기능 요청 등을 공유하세요</p>
      </div>

      {message && <div className="message success">{message}</div>}

      {canPost && !showWriteForm && (
        <button className="write-btn" onClick={() => setShowWriteForm(true)}>
          이슈 등록
        </button>
      )}

      {showWriteForm && (
        <form onSubmit={handleCreatePost} className="write-form">
          <input
            type="text"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
            placeholder="이슈 제목"
            required
          />
          <CommunityEditor
            value={newContent}
            onChange={setNewContent}
            placeholder="이슈 내용을 상세히 작성해주세요"
            minHeight={200}
          />
          <div className="form-actions">
            <button type="button" onClick={() => setShowWriteForm(false)} className="cancel-btn">
              취소
            </button>
            <button type="submit" className="submit-btn">
              등록
            </button>
          </div>
        </form>
      )}

      <div className="posts-list">
        {posts.length === 0 ? (
          <p className="no-posts">등록된 이슈가 없습니다.</p>
        ) : (
          posts.map((post) => (
            <div key={post.id} className="post-card" onClick={() => onPostSelect(post)}>
              <div className="post-card-header">
                <span className="post-badge category-question">이슈</span>
                <h3>{post.title}</h3>
              </div>
              <div className="post-card-meta">
                <span className="author">{post.author.name}</span>
                <span className="date">{formatDate(post.createdAt)}</span>
                <span className="comments">댓글 {post.comments?.length || 0}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default IssueBoardSection;
